/* eslint-disable no-extra-boolean-cast */
/* eslint-disable eqeqeq */
function webpSupport () {
  var el = document.createElement('canvas')
  if (!!(el.getContext && el.getContext('2d'))) {
    return el.toDataURL('image/webp').indexOf('data:image/webp') == 0
  }
  return false
}

function setWebpClassSupport (hasSupport) {
  var htmlEl = document.querySelector('html')
  var classSupport = (hasSupport) ? 'webp' : 'no-webp'
  htmlEl.className += ' ' + classSupport
  htmlEl.className = htmlEl.className.trim()
}

export default function initialize () {
  setWebpClassSupport(webpSupport())
}
